export default function PageHeader({ eyebrow, title, subtitle, align = "left" }) {
  return (
    <section className="relative border-b border-white/10 bg-obsidian">
      <div className="absolute inset-0 bg-grid opacity-30" />
      <div className={`relative max-w-7xl mx-auto px-5 lg:px-8 py-24 lg:py-32 ${align === "center" ? "text-center" : ""}`}>
        {eyebrow && <div className="chip text-neon-green">{eyebrow}</div>}
        <h1 className="mt-3 font-display font-black text-4xl sm:text-5xl lg:text-7xl text-white tracking-tighter leading-[0.95] max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 max-w-2xl text-white/60 text-base leading-relaxed font-mono">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
